import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../components/modal/delete-modal";
import { TextView } from "../../components/view-form-components/text-view";
import { useEffect } from "react";
import { DocumentView } from "../../components/view-form-components/image.view";
import ViewLocationMap from "../../components/view-form-components/location-view";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import ShareModal from "../modal/share-modal";

const ViewCustomerComponent = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.customer;

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/customer/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/customer/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/company/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const writePermission = (row) => {
    if (row?.assignedTo) {
      if (row?.assignedTo.write == true) {
        return true;
      }
      return false;
    }
    if (permission?.write == true) {
      return true;
    }
  };

  return (
    <section className="relative">
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="customer"
        modulelabel="customer"
      />
      <section className="overflow-auto px-3">
        <div className="flex md:flex-row flex-col-reverse justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">customer - view</h2>
          <div className="flex gap-3 items-center">
            {writePermission(data) && (
              <button
                onClick={() => {
                  setShareModalShow(true);
                }}
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                share
              </button>
            )}

            {writePermission(data) && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/customer/edit/${params?.id}`}
              >
                edit
              </Link>
            )}

            {writePermission(data) && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <TextView label={"Name"} value={data?.name ?? "--"} />
            <TextView label={"address"} value={data?.address ?? "--"} />
            <TextView label={"state"} value={data?.state?.name ?? "--"} />
            <TextView label={"city"} value={data?.city?.name ?? "--"} />
            <DocumentView
              label={"visiting card photo"}
              value={data?.visiting_card_photo}
            />
            <DocumentView
              label={"outside place photo"}
              value={data?.outside_place_photo}
            />
            <TextView
              label={"contact name"}
              value={data?.contact_name ?? "--"}
            />
            <TextView
              label={"contact number"}
              value={data?.contact_number ?? "--"}
            />
            <TextView
              label={"type of client"}
              value={data?.type_of_client ?? "--"}
            />
            <TextView
              label={"price agreed upon"}
              value={data?.price_agreed_upon ?? "--"}
            />
            <TextView
              label={"type_of_billing"}
              value={data?.type_of_billing ?? "--"}
            />
            <TextView label={"status"} value={data?.status ?? "--"} />
            <TextView
              label={"billing name"}
              value={data?.billing_name ?? "--"}
            />
            <TextView
              label={"billing address"}
              value={data?.billing_address ?? "--"}
            />
            <TextView
              label={"billing State"}
              value={data?.billingState?.name ?? "--"}
            />
            <TextView
              label={"billing City"}
              value={data?.billingCity?.name ?? "--"}
            />
            <TextView
              label={"billing pincode"}
              value={data?.billing_pincode ?? "--"}
            />
            <TextView label={"pan number"} value={data?.pan_number ?? "--"} />
            <TextView label={"gst number"} value={data?.gst_number ?? "--"} />
            <TextView
              label={"last order on"}
              value={data?.last_order_on ?? "--"}
            />
            <TextView
              label={"created_by"}
              value={data?.createdBy?.name ?? "--"}
            />
            <TextView
              label={"assigned To"}
              value={data?.assignedTo?.name ?? "--"}
            />
            <ViewLocationMap
              label={"location"}
              lat={data?.location?.lat ?? ""}
              lng={data?.location.lng ?? ""}
            />
          </div>
        </section>
      </section>
    </section>
  );
};

export default ViewCustomerComponent;
